import JaneStreet from '../assets/sponsors_imgs/janestreet.png';
import Leidos from '../assets/sponsors_imgs/leidos.svg';
import ASML from '../assets/sponsors_imgs/asml.svg';
import Visa from '../assets/sponsors_imgs/visa.webp';
import Apple from '../assets/sponsors_imgs/apple.svg';
import SouthernCaliforniaEdison from '../assets/sponsors_imgs/sce.png';

const Sponsors = [
  {
    image: JaneStreet,
  },
  {
    image: Leidos,
  },
  {
    image: ASML,
  },
  {
    image: Visa,
  },
  {
    image: Apple,
  },
  {
    image: SouthernCaliforniaEdison,
  },
];

export default Sponsors;
